import React from 'react';

import { TextIframeBlock } from '@/app/_components/TextIframeBlock';
import { TextIframeBlockProps } from './types';

import classes from './index.module.scss';

export const TextIframeBlockGraphQL: React.FC<TextIframeBlockProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <TextIframeBlock textIframeBlock={props} />
    </div>
  );
};

export default TextIframeBlockGraphQL;
